import request from '../request';

function recitePoints(id,q) {
  return request({
    url: `/fivePointsEach/recitePoints/${id}`,
    params:{qString:q},
    method: 'get',
  });
}

function fivePoints(q) {
  return request({
    url: `/fivePointsEach/fivePoints`,
    params:q,
    method: 'get'
  });
}

function updatePoints(id,type,data) {
  return request({
    url: `/fivePointsEach/updatePoints/${id}/${type}`,
    data:data,
    method: 'post'
  });
}

function mustBatch(id,mid,data) {
  return request({
    url: `/fivePointsEach/mustBatch/${id}/${mid}`,
    data:data,
    method: 'post'
  });
}

export default {
  recitePoints,
  fivePoints,
  updatePoints,
  mustBatch
};